// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".affirm-as-low-as[data-v-424c8962] .affirm-ala-price{font-weight:var(--fontWeightBold)}.affirm-as-low-as[data-v-424c8962] .__affirm-logo{font-size:var(--fontSizeBase)}.affirm-as-low-as[data-v-424c8962] .affirm-modal-trigger{color:var(--colorGrayDark);font-size:var(--fontSizeXs);font-weight:var(--fontWeightBold);-webkit-text-decoration:underline;text-decoration:underline;white-space:nowrap}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
